import { cleanupClouds } from './handleClouds';

/**
 * Clean up a particle system's custom updates, global animation manager registrations,
 * and dispose of its Three.js geometries/materials to prevent memory leaks.
 */
export const cleanupParticleSystem = (obj) => {
  if (!obj) return;

  // Specific unregistration from clouds global manager
  if (
    obj.objType === 'clouds' ||
    (obj.deleteType === 'particle' &&
      (obj.name === 'clouds' || obj.name?.startsWith('clouds_')))
  ) {
    cleanupClouds(obj);
  }

  // Custom cleanups (e.g. for foliage or terrain)
  if (typeof obj.cleanup === 'function') {
    try {
      obj.cleanup();
    } catch (e) {
      console.warn('Error running obj.cleanup:', e);
    }
  }

  if (obj.userData && typeof obj.userData.cleanup === 'function') {
    try {
      obj.userData.cleanup();
    } catch (e) {
      console.warn('Error running obj.userData.cleanup:', e);
    }
  }

  // Dispose geometries and materials recursively
  obj.traverse((child) => {
    if (child.geometry) {
      try {
        child.geometry.dispose();
      } catch (_) {}
    }
    if (child.material) {
      try {
        if (Array.isArray(child.material)) {
          child.material.forEach((m) => m?.dispose());
        } else {
          child.material.dispose();
        }
      } catch (_) {}
    }
  });
};
